import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchCultures } from '@app/api'
import { getUserLanguage } from '@app/utils'

export const getCulturesThunk = createAsyncThunk('cultures', async () => {
  const userLanguage = getUserLanguage()

  return await fetchCultures(userLanguage)
})
